import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["operator", "value", "dateInputs"]
  static values = { index: Number }

  connect() {
    // Initial setup if needed
  }

  updateOperator(event) {
    if (this.hasDateInputsTarget) {
      this.updateDateInputs();
    }
  }

  updateDateInputs() {
    const operator = this.operatorTarget.value
    const container = this.dateInputsTarget
    const index = this.indexValue
    container.innerHTML = ""

    if (operator === "between") {
      const div1 = document.createElement("div")
      div1.className = "mb-2"
      div1.innerHTML = `<input type="text" name="filters[${index}][value][]" class="w-full border border-gray-300 rounded focus:outline-none shadow-inner ring-0 text-gray-800" placeholder="Start Date" data-controller="datepicker" data-data-rows-filter-target="value">`

      const div2 = document.createElement("div")
      div2.innerHTML = `<input type="text" name="filters[${index}][value][]" class="w-full border border-gray-300 rounded focus:outline-none shadow-inner ring-0 text-gray-800" placeholder="End Date" data-controller="datepicker" data-data-rows-filter-target="value">`

      container.appendChild(div1)
      container.appendChild(div2)
    } else {
      const div = document.createElement("div")
      div.innerHTML = `<input type="text" name="filters[${index}][value]" class="w-full border border-gray-300 rounded focus:outline-none shadow-inner ring-0 text-gray-800" placeholder="Select Date" data-controller="datepicker" data-data-rows-filter-target="value">`
      container.appendChild(div)
    }
  }
}
